import React from "react";
import { ArcBox } from "@src/core/ui";
import {
  OrderEntity,
  OrderMissionEntity,
  OrderStatusEnum,
} from "@src/features/order/entities";
import ArcOrderCardDetails from '@src/core/components/arc-order-card-details';
import { SxProps } from "@mui/material";

interface ArcOrderCardProps {
  order: OrderEntity | OrderMissionEntity;
  isSelected: boolean;
  onClick: () => void;
  index: number;
  status?: OrderStatusEnum;
  fullWidth?: boolean;
  sx?: SxProps;
  isInFlight?: boolean;
}

const ArcOrderCard: React.FC<ArcOrderCardProps> = ({
  order,
  isSelected,
  onClick,
  index,
  status,
  fullWidth = false,
  sx,
  isInFlight = false,
}) => {

  const isErrorCard = status === OrderStatusEnum.ERROR && !fullWidth;

  return (
    <ArcBox
      key={index}
      p={1.5}
      width={fullWidth ? "100%" : "calc(50% - 4px)"}
      bgcolor={isErrorCard ? "rose.main" : "grey.900"}
      borderRadius={1}
      sx={{
        cursor: "pointer",
        "&:hover": {
          bgcolor: isErrorCard ? "rose.main" : "grey.800",
        },
        border: "1px solid",
        borderColor: isSelected ? "brand.main" : isErrorCard ? "rose.main" : "grey.900",
        ...sx,
      }}
      onClick={onClick}
    >
      <ArcOrderCardDetails order={order} fullWidth={fullWidth} isInFlight={isInFlight} status={status} />
    </ArcBox>
  );
};

export default ArcOrderCard;
